import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { useEffect, useState } from "react";
import { BASE_API_URL } from "../utils/constants";
import "./Analytics.css";

function Analytics() {
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  const loggedInEnterpriseId = activeAccount?.idTokenClaims?.enterpriseID || "";

  useEffect(() => {
    let isMounted = true;

    const fetchAnalytics = async () => {
      const token = localStorage.getItem("token");

      if (!token || !loggedInEnterpriseId) return;

      try {
        setLoading(true);

        await axios.post(
          `${BASE_API_URL}/analytics`,
          { enterprise_id: loggedInEnterpriseId },
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          },
        );

        const response = await axios.get(`${BASE_API_URL}/analytics`, {
          headers: {
            Authorization: token,
          },
        });

        if (isMounted) {
          setAnalytics(response.data?.[0] || null);
        }
      } catch (err) {
        console.log(err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchAnalytics();

    return () => {
      isMounted = false;
    };
  }, [loggedInEnterpriseId]);

  const totalUserViews = analytics?.totalUniqueUsers ?? 0;
  const totalViews = analytics?.Data?.totalSum ?? 0;

  return (
    <span className="analytics-span">
      {loading ? (
        "Loading analytics..."
      ) : (
        <>
          Total Views: {totalViews} &nbsp; | &nbsp; Unique Views:{" "}
          {totalUserViews}
        </>
      )}
    </span>
  );
}

export default Analytics;
